import * as BABYLON from "@babylonjs/core";
import { CanvasDisplay, CanvasMap } from "core/map/canvas";
import { Assert } from "core/utils";
export class WebMapTexture extends BABYLON.Texture {
    static Options(o) {
        return { ...WebMapTexture.DefaultOptions, ...(o ?? {}) };
    }
    static OptionsHD(o) {
        return { ...WebMapTexture.DefaultOptions, ...(o ?? {}), width: 1280, height: 720 };
    }
    static OptionsFullHD(o) {
        return { ...WebMapTexture.DefaultOptions, ...(o ?? {}), width: 1980, height: 1080 };
    }
    static Options4K(o) {
        return { ...WebMapTexture.DefaultOptions, ...(o ?? {}), width: 3840, height: 2160 };
    }
    static Options8K(o) {
        return { ...WebMapTexture.DefaultOptions, ...(o ?? {}), width: 7680, height: 4320 };
    }
    constructor(name, options, scene, nav) {
        const o = { ...WebMapTexture.DefaultOptions, ...options };
        super(null, scene, !o.generateMipMaps, o.invertY, o.samplingMode, undefined, undefined, undefined, undefined, o.format);
        this._display = null;
        this._map = null;
        this._renderObserver = null;
        this.name = name;
        this.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE;
        this.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE;
        const engine = this._getEngine();
        Assert(engine !== null, "unable to get engine");
        const canvas = engine.createCanvas(options.width, options.height);
        Assert(canvas !== null && canvas != undefined, "unable to create canvas");
        this._texture = engine.createDynamicTexture(options.width, options.height, o.generateMipMaps, o.samplingMode);
        this._display = new CanvasDisplay(canvas, 1, false);
        this._map = new CanvasMap(this._display, o, nav);
        this._renderObserver = scene.onBeforeCameraRenderObservable.add(this._checkUpdate.bind(this));
    }
    get map() {
        return this._map;
    }
    dispose() {
        super.dispose();
        if (this._renderObserver) {
            this.getScene()?.onBeforeCameraRenderObservable.remove(this._renderObserver);
        }
        this._map?.dispose();
        this._display?.dispose();
    }
    _checkUpdate(camera, eventState) {
        if (this._map && this._display) {
            if (this._map.isValid == false) {
                this._map.validate();
                this._getEngine().updateDynamicTexture(this._texture, this._display.canvas, this._invertY, false, this._format || undefined, undefined, false);
            }
        }
    }
}
WebMapTexture.DefaultOptions = {
    width: 1024,
    height: 768,
    generateMipMaps: false,
    samplingMode: BABYLON.Constants.TEXTURE_TRILINEAR_SAMPLINGMODE,
    format: BABYLON.Constants.TEXTUREFORMAT_RGBA,
    invertY: false,
};
//# sourceMappingURL=textures.webMapTexture.js.map